import { createRuntimeFn } from '@vanilla-extract/recipes/createRuntimeFn';

var FOG_HEIGHT = 80;
var contentPositioner = createRuntimeFn({defaultClassName:'fx_2d2fb1e5_h7q6ib3',variantClassNames:{modal:{true:'fx_2d2fb1e5_h7q6ib4',false:'fx_2d2fb1e5_h7q6ib5'},placement:{center:'fx_2d2fb1e5_h7q6ib6',top:'fx_2d2fb1e5_h7q6ib7',bottom:'fx_2d2fb1e5_h7q6ib8',left:'fx_2d2fb1e5_h7q6ib9',right:'fx_2d2fb1e5_h7q6iba'}},defaultVariants:{},compoundVariants:[]});
var scrollAreaViewPort = 'fx_2d2fb1e5_h7q6ibd';
var scrollAreaViewPortPaddingBottom = 'var(--fx_2d2fb1e5_h7q6ibb)';
var scrollAreaViewPortPaddingTop = 'var(--fx_2d2fb1e5_h7q6ibc)';

export { FOG_HEIGHT, contentPositioner, scrollAreaViewPort, scrollAreaViewPortPaddingBottom, scrollAreaViewPortPaddingTop };
//# sourceMappingURL=styles.vanilla.mjs.map
